import { AbstractMapLayerProviderList } from 'app/config/AbstractMapLayerProviderList';
import { ImsImageryProvider } from 'app/config/ImsImageryProvider';
import { MapLayerOptionsHelper } from 'app/overview/config/data/MapLayerOptionsHelper';

export class ImsImageryProviderList extends AbstractMapLayerProviderList<ImsImageryProvider> {
    constructor(providers: ImsImageryProvider[] = []) {
        super(providers);
    }

    clone(): this {
        return new ImsImageryProviderList(this._providers.map((p) => p.clone())) as any;
    }
}

/**
 * Create from plain old javascript dicts that are received from the API; NOTE: in this case
 * received from the API actually means "defined statically in the API's settings.py" (though
 * arguably extensible / overridable w/ the API's local_settings.py)
 * @returns {ImsImageryProviderList}
 */
export function createImageryProviderListFromJS(
    imageryProviderJSArray: any[],
    mapOptionsHelper: MapLayerOptionsHelper,
): ImsImageryProviderList {
    const providers = (imageryProviderJSArray || []).map(
        (js) => new ImsImageryProvider(js, mapOptionsHelper),
    );
    return new ImsImageryProviderList(providers);
}
